/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  filter: 'filter',
  PRICE_ASC: 'PRICE_ASC',
  PRICE_DESC: 'PRICE_DESC',
  OUTBOUNDDEPARTURETIME_ASC: 'OUTBOUNDDEPARTURETIME_ASC',
  OUTBOUNDDEPARTURETIME_DESC: 'OUTBOUNDDEPARTURETIME_DESC',
  OUTBOUNDARRIVALTIME_ASC: 'OUTBOUNDARRIVALTIME_ASC',
  OUTBOUNDARRIVALTIME_DESC: 'OUTBOUNDARRIVALTIME_DESC',
  INBOUNDDEPARTURETIME_ASC: 'INBOUNDDEPARTURETIME_ASC',
  INBOUNDDEPARTURETIME_DESC: 'INBOUNDDEPARTURETIME_DESC',
  INBOUNDARRIVALTIME_ASC: 'INBOUNDARRIVALTIME_ASC',
  INBOUNDARRIVALTIME_DESC: 'INBOUNDARRIVALTIME_DESC',
  NUMBEROFSTOPS_ASC: 'NUMBEROFSTOPS_ASC',
  NUMBEROFSTOPS_DESC: 'NUMBEROFSTOPS_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  PROMOTIONS_ASC: 'PROMOTIONS_ASC',
  STARS_ASC: 'STARS_ASC',
  STARS_DESC: 'STARS_DESC',
  DURATION_ASC: 'DURATION_ASC',
  DURATION_DESC: 'DURATION_DESC',
  CATEGORY_ASC: 'CATEGORY_ASC',
  CATEGORY_DESC: 'CATEGORY_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  SortBy: 'SortBy',
  PleaseSelect: 'PleaseSelect',
  PRICE_RANGE: 'PRICE_RANGE',
  PACKAGE_LOCATION: 'PACKAGE_LOCATION',
  EXTRA_PRICE_RANGE: 'EXTRA_PRICE_RANGE',
  DINING_PRICE_RANGE: 'DINING_PRICE_RANGE',
  HOTEL_PRICE_RANGE: 'HOTEL_PRICE_RANGE',
  HOTEL_DISTANCE_LIMIT: 'HOTEL_DISTANCE_LIMIT',
  FLIGHT_PRICE_RANGE: 'FLIGHT_PRICE_RANGE',
  CHARACTERISTICS: 'CHARACTERISTICS',
  HOTEL_CATEGORY: 'HOTEL_CATEGORY',
  HOTEL_SERVICE_TYPE: 'HOTEL_SERVICE_TYPE',
  HOTEL_SERVICE_OPTIONS: 'HOTEL_SERVICE_OPTIONS',
  EXTRA_CATEGORY: 'EXTRA_CATEGORY',
  EXTRA_SERVICE_TYPE: 'EXTRA_SERVICE_TYPE',
  EXTRA_SUBCATEGORY: 'EXTRA_SUBCATEGORY',
  PACKAGE_CATEGORY: 'PACKAGE_CATEGORY',
  PACKAGE_DURATION: 'PACKAGE_DURATION',
  PACKAGE_PRICE_RANGE: 'PACKAGE_PRICE_RANGE',
  THEMES: 'THEMES',
  SERVICE_OPTIONS: 'SERVICE_OPTIONS',
  DINING_SERVICE_OPTIONS: 'DINING_SERVICE_OPTIONS',
  STARS: 'STARS',
  DURATION: 'DURATION',
  FLIGHT_DURATION: 'FLIGHT_DURATION',
  FLIGHT_NUMBER_OF_STOPS: 'FLIGHT_NUMBER_OF_STOPS',
  FLIGHT_AIRLINES: 'FLIGHT_AIRLINES',
  FLIGHT_TIMES: 'FLIGHT_TIMES',
  CAR_TYPE: 'CAR_TYPE',
  CAR_SUPPLIER: 'CAR_SUPPLIER',
  AIR_CONDITION: 'AIR_CONDITION',
  FUEL_TYPE: 'FUEL_TYPE',
  TRANSMISSION: 'TRANSMISSION',
  SEATS_COUNT: 'SEATS_COUNT',
  BAGS_COUNT: 'BAGS_COUNT',
  CAR_CATEGORY: 'CAR_CATEGORY',
  CAR_PRICE_RANGE: 'CAR_PRICE_RANGE',
  CAR_SERVICE_TYPE: 'CAR_SERVICE_TYPE',
  CAR_TRANSMISSION: 'CAR_TRANSMISSION',
  CAR_SEATS_COUNT: 'CAR_SEATS_COUNT',
  CAR_BAGS_COUNT: 'CAR_BAGS_COUNT',
  CAR_DOORS_COUNT: 'CAR_DOORS_COUNT',
  CAR_FUEL_TYPE: 'CAR_FUEL_TYPE',
  CAR_AIR_CONDITION: 'CAR_AIR_CONDITION',
  CAR_DISTANCE_LIMIT: 'CAR_DISTANCE_LIMIT',
  TRANSFER_PRICE_RANGE: 'TRANSFER_PRICE_RANGE',
  DOORS_COUNT: 'DOORS_COUNT',
  CATEGORIES: 'CATEGORIES',
  EXTRA_CATEGORIES: 'EXTRA_CATEGORIES',
  TIME_OF_DAY: 'TIME_OF_DAY',
  EXERTION_LEVEL: 'EXERTION_LEVEL',
  RISK: 'RISK',
  LANGUAGE: 'LANGUAGE',
  CUISINE: 'CUISINE',
  MENU_OPTIONS: 'MENU_OPTIONS',
  STYLE: 'STYLE',
  AMENITIES: 'AMENITIES',
  FACILITIES: 'FACILITIES',
  BED_PREFERENCES: 'BED_PREFERENCES',
  HOTEL_THEMES: 'HOTEL_THEMES',
  PROMOTIONS: 'PROMOTIONS',
  STAY_TYPE: 'STAY_TYPE',
  THEME: 'THEME',
  discardFilters: 'discardFilters',
  filterResults: 'filterResults',
  MAP: 'MAP',
  TRANSFER_CATEGORY: 'TRANSFER_CATEGORY',
  TRANSFER_SEATS_COUNT: 'TRANSFER_SEATS_COUNT',
  TRANSFER_BAGS_COUNT: 'TRANSFER_BAGS_COUNT',
  LOUNGE_ACCESS_PRICE_RANGE: 'LOUNGE_ACCESS_PRICE_RANGE',
  MEET_AND_GREET_PRICE_RANGE: 'MEET_AND_GREET_PRICE_RANGE',
  MEET_AND_GREET_SERVICE_TYPE: 'MEET_AND_GREET_SERVICE_TYPE',
  CAMPER_PRICE_RANGE: 'CAMPER_PRICE_RANGE',
  CAMPER_CATEGORY: 'CAMPER_CATEGORY',
  CAMPER_SUBCATEGORY: 'CAMPER_SUBCATEGORY',
  CAMPER_BEDS_COUNT: 'CAMPER_BEDS_COUNT',
  CAMPER_SERVICE_OPTIONS: 'CAMPER_SERVICE_OPTIONS',
  CAMPER_CHARACTERISTICS: 'CAMPER_CHARACTERISTICS',
  CAMPER_SUPPLIER: 'CAMPER_SUPPLIER',
  HOTEL_AMENITY: 'HOTEL_AMENITY',
  HOTEL_ROOM_AMENITY: 'HOTEL_ROOM_AMENITY',
  select: 'select',
  PRICE_LABEL: 'PRICE_LABEL',
  PRICEDATE_LABEL: 'PRICEDATE_LABEL',
  NAME_LABEL: 'NAME_LABEL',
  STARS_LABEL: 'STARS_LABEL',
  DURATION_LABEL: 'DURATION_LABEL',
  CATEGORY_LABEL: 'CATEGORY_LABEL',
  TYPE_LABEL: 'TYPE_LABEL',
  OUTBOUNDDEPARTURETIME_LABEL: 'OUTBOUNDDEPARTURETIME_LABEL',
  OUTBOUNDARRIVALTIME_LABEL: 'OUTBOUNDARRIVALTIME_LABEL',
  INBOUNDDEPARTURETIME_LABEL: 'INBOUNDDEPARTURETIME_LABEL',
  INBOUNDARRIVALTIME_LABEL: 'INBOUNDARRIVALTIME_LABEL',
  NUMBEROFSTOPS_LABEL: 'NUMBEROFSTOPS_LABEL',
  PROMOTIONS_LABEL: 'PROMOTIONS_LABEL',
  results_per_page: 'results_per_page',
  hits: 'hits',
  apply: 'apply',
  RESET: 'RESET'
}; export default Keys;